import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData, getNoSlip } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/Grid/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import SnButton from "@shared/components/SnButton";
import SnDateBox from "@shared/components/SnDateBox";
import SnCodeBox from "@shared/components/SnCodeBox";
import SnComboBox from "@shared/components/SnComboBox";
import SnLabel from "@shared/components/SnLabel";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";

let grid4result: any[] = [];

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_SAL_STX_REG_002 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridApiRefH = useRef<any>(null);
  const gridApiRefL = useRef<any>(null);
  const gridApiRefS = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global();
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns1, setColums1] = useState<any[]>([]);
  const [columns2, setColums2] = useState<any[]>([]);
  const [columns3, setColums3] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any[]>([]);
  const [dataSource2, setDataSource2] = useState<any>();
  const [dataSource3, setDataSource3] = useState<any>();
  //#endregion

  //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "SN_SAL_STX_REG_002";
  const defaultSize = {
    panel1: "49.5%",
    panel2: "49.5%",
    panel3: "49.5%",
    panel4: "49.5%",
  };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      setDataSource2([]);
      setDataSource3([]);
      try {
        const rtn: any = await getInitFormData({});
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        setFormData(rtn.formData); // 조회조건 초기값
        setColums1(rtn.grid.grid1); // H그리드 항목 설정
        setColums2(rtn.grid.grid2); // L그리드 항목 설정
        setColums3(rtn.grid.grid3); // L그리드 항목 설정

        // const params = {
        //   id: "sn_sal_stx_reg_002_01",
        //   params: rtn.initformData,
        // };
      } catch (error) {}
    };
    fetchform();
  }, []);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRowsH = gridApiRefH.current.getChange();
    const modifiedRowsL = gridApiRefL.current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const params = {
        id: "sn_sal_stx_reg_002_01",
        params: searchRef.current.getFormdata(),
      };
      setDataSource1([]);
      setDataSource2([]);
      setDataSource3([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      setDataSource2(data[1] || []);

      if (data[0] && data[0].length > 0) {
        // 1. 그리드 데이터가 바인딩되었음을 기다림
        await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

        // 2. 첫 번째 행 선택 및 포커스 설정
        gridApiRefH.current.selectAndFocusRow(0);
      }

      gridApiRefH.current.resetUpdate();
      gridApiRefL.current.resetUpdate();
      gridApiRefS.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onAddRow = async () => {
    try {
      const newRow = {}; // 빈 객체
      gridApiRefL.current?.addRow(newRow);
    } catch (error: any) {}
  };

  const onSave = async () => {
    let returnMsg = "";
    let lineNo = 1;
    let salstxH;
    let salstxL;

    try {
      gridApiRefS.current?.api.stopEditing();
      const requiredValuesCheckS = gridApiRefS.current.requiredValuesCheck();
      if (!requiredValuesCheckS) {
        return;
      }

      salstxH = gridApiRefS.current.getChange();
      salstxL = gridApiRefS.current.getChange();
      const headerInserts = salstxH.insert ?? [];
      if (salstxH.modifiedRowcount === 0 && salstxL.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      for (let row of headerInserts) {
        if (!row.no_sales) {
          gridApiRefS.current.api.ensureIndexVisible(row);
          gridApiRefS.current.api.setFocusedCell(row, "NO_SALES");
          const cd_module: any = Menuprops.cd_module;
          const cd_menu: any = Menuprops.cd_menu;
          try {
            // getNoSlip 호출
            const no_slip = await getNoSlip(
              cd_module,
              3, // no_line 값이 필요한 경우 사용
              "STX", // cd_prefix 값이 필요하다면 여기에 적어주세요.
              todayform, // 해당 날짜를 넘겨줘야 할 경우
              cd_menu // cd_menu 값
            );
            if (no_slip) {
              row.no_sales = no_slip;

              const rowNode = gridApiRefS.current.api.getRowNode(row);
              if (rowNode) {
                rowNode.setDataValue("no_sales", no_slip);
              }
              for (let j = 0; j < grid4result.length; j++) {
                if (row.no_id === grid4result[j].no_id) {
                  grid4result[j].no_sales = no_slip;
                  grid4result[j].no_line = lineNo++;
                }
              }
              lineNo = 1;
            }
          } catch (error) {}
        }
      }

      const SaveData = {
        sal_salesh: salstxH,
        sal_salesl: { insert: grid4result },
      };

      await fnSave("SN_SAL_STX_REG_002_SAVE_01", SaveData);

      gridApiRefS.current.resetUpdate();
    } catch (error: any) {
      if (salstxH.delete?.length > 0) {
        gridApiRefL.current.api.applyTransaction({ add: salstxL.delete });
      }

      if (salstxH?.delete?.length > 0) {
        const res = gridApiRefH.current.api.applyTransaction({
          add: salstxH.delete,
        });

        // 첫 번째 복구된 행 자동 선택 & 포커스 이동
        if (res.add && res.add.length > 0) {
          const firstRestoredRow = res.add[0]; // 첫 번째 복구된 행
          gridApiRefH.current?.selectAndFocusRow(firstRestoredRow.rowIndex);
        }

        // 변경 버퍼 초기화 (Insert / Update / Delete 버퍼 리셋)
        gridApiRefH.current.resetUpdate();
        gridApiRefL.current.resetUpdate();
      }
    }
  };
  //#endregion

  //#region  Event Method

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      // 배열로 만들어서 필터링 함수 호출
      const cd_cust = selectedRow.cd_cust;
      gridApiRefL.current.applyFilters({ cd_cust: cd_cust });
      gridApiRefL.current.selectAndFocusRow(0);
    } else {
      return;
    }
  };
  const grid3Btnclick = async (id: string) => {
    if (id == "clsdev") {
      const grid1RowCount = gridApiRefH.current.api.getSelectedRows();
      const grid3RowCount = gridApiRefS.current.api.getDisplayedRowCount();

      if (grid1RowCount.length == 0) {
        await showDialog("error", "마감 전개 대상이 없습니다.");
        return;
      }
      if (grid3RowCount > 0) {
        await showDialog("error", "마감 전개 건이 존재함니다.");
        return;
      }
      const selectedFormData = searchRef.current.getFormdata();
      const selectedData = {
        cd_biz: selectedFormData.cd_biz,
      };

      try {
        let noIo = "";
        let cdempvale;

        grid1RowCount.forEach((row: any) => {
          gridApiRefL.current.api.forEachNode((node: any) => {
            if (row.cd_cust === node.data?.cd_cust) {
              noIo += node.data?.no_io + ",";
            }
          });
        });
        noIo = noIo.substring(0, noIo.length - 1);
        const params = {
          id: "sn_sal_stx_reg_002_02",
          params: {
            cd_firm: userInfo.cd_firm,
            cd_biz: selectedData.cd_biz,
            no_io: noIo,
          },
        };
        const data: any = await fnGetDataSet(params);
        if (data.length === 0) {
          await showDialog("error", "no data");
          return;
        }
        for (let row of data[0]) {
          const newRow = {};
          gridApiRefS.current?.addRow(newRow);
          const rowCount = gridApiRefS.current.api.getDisplayedRowCount();
          const lastRowIndex = rowCount - 1;

          // 마지막 행에 대한 rowNode를 가져오기
          const lastRowNode =
            gridApiRefS.current.api.getDisplayedRowAtIndex(lastRowIndex);
          gridApiRefS.current.setValue(
            lastRowNode,
            "cd_firm",
            userInfo.cd_firm
          );
          gridApiRefS.current.setValue(lastRowNode, "no_sales", "");
          gridApiRefS.current.setValue(lastRowNode, "cd_cust", row.cd_cust);
          gridApiRefS.current.setValue(
            lastRowNode,
            "cd_cust_sales",
            row.cd_cust
          );
          gridApiRefS.current.setValue(lastRowNode, "cd_cust_col", row.cd_cust);
          gridApiRefS.current.setValue(lastRowNode, "nm_cust", row.nm_cust);
          gridApiRefS.current.setValue(lastRowNode, "fg_vat", row.fg_vat ?? "");
          gridApiRefS.current.setValue(lastRowNode, "am_k", row.am_k);
          gridApiRefS.current.setValue(lastRowNode, "am_vat", row.am_vat);
          gridApiRefS.current.setValue(lastRowNode, "am_k_col_s", 0);
          gridApiRefS.current.setValue(lastRowNode, "am_supply", row.am_supply);
          gridApiRefS.current.setValue(lastRowNode, "rt_exch", row.rt_exch);
          gridApiRefS.current.setValue(lastRowNode, "no_id", row.no_id);
          gridApiRefS.current.setValue(lastRowNode, "dt_sales", todayform);
          gridApiRefS.current.setValue(lastRowNode, "dt_col_plan", todayform);
          gridApiRefS.current.setValue(
            lastRowNode,
            "cd_biz",
            selectedData.cd_biz
          );
          gridApiRefS.current.setValue(
            lastRowNode,
            "cd_dept",
            userInfo.cd_dept
          );
          if (cd_empL == null) {
            cdempvale = userInfo.cd_emp;
          } else {
            cdempvale = cd_empL;
          }
          gridApiRefS.current.setValue(lastRowNode, "cd_emp", cdempvale);
          gridApiRefS.current.setValue(lastRowNode, "cd_gp", cd_groupL);
          gridApiRefS.current.setValue(lastRowNode, "fg_trns", "1");
          gridApiRefS.current.setValue(lastRowNode, "cd_exch", row.cd_exch);
          gridApiRefS.current.setValue(lastRowNode, "am", row.am);
          gridApiRefS.current.setValue(lastRowNode, "yn_autoprocess", "N");
          gridApiRefS.current.setValue(lastRowNode, "cd_cust_own", "");
          gridApiRefS.current.setValue(lastRowNode, "cd_partner", "");
          gridApiRefS.current.setValue(lastRowNode, "cd_person", "");
          gridApiRefS.current.setValue(lastRowNode, "st_sales", "");
          gridApiRefS.current.setValue(lastRowNode, "fg_etax", "1");
          gridApiRefS.current.setValue(lastRowNode, "cd_fin", "");
          gridApiRefS.current.setValue(lastRowNode, "dy_pay", 0);
          gridApiRefS.current.setValue(lastRowNode, "yn_app", "");
        }
        grid4result = data[1];
      } catch (error: any) {
        throw error;
      }
    }
  };
  const [adateEditpur, setSelectedValue] = useState<string>("");
  const onValueChanged = async (value: string) => {
    setSelectedValue(value);
  };
  const [adateEditplanpay, setSelectedValue1] = useState<string>("");
  const onValueChanged1 = async (value: string) => {
    setSelectedValue1(value);
  };
  const [cd_groupL, setSelectedValue2] = useState<string>("");
  const onValueChanged2 = async (value: string) => {
    setSelectedValue2(value);
  };
  const [cd_empL, setSelectedValue3] = useState<string>("");
  const onValueChanged3 = async (value: string) => {
    setSelectedValue3(value);
  };
  //#endregion

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        />
      </div>
      <div className="flex w-full h-full flex-col space-y-1.5 overflow-y-hidden">
        <SnResizable
          direction={"height"}
          seq={4}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel4}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minWidth={130}
        >
          <div className="flex w-full h-full min-w-0 space-x-3.5">
            <SnResizable
              direction={"width"}
              seq={1}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panel1}
              onResizeStop={onResizeStop}
              enable={{ right: true }}
              minHeight={130}
            >
              <SnGrid
                
                seq={1}
                ref={gridApiRefH}
                columnConfig={columns1}
                rowData={dataSource1}
                isEditable={false}
                rowSelection="multiple"
                onFocusedRowChanged={onFocusedRowChanged}
                ischeckboxSelection={true}
                resizeController={{
                  defaultSize: defaultSize,
                  onResizeStop: onResizeStop,
                }}
              />
            </SnResizable>
            <SnResizable
              direction={"width"}
              seq={2}
              cd_menu={cd_menu}
              defaultSize={defaultSize}
              size={sizes.panel2}
              onResizeStop={onResizeStop}
              enable={{ right: true }}
              minHeight={130}
            >
              <SnGrid
                
                seq={2}
                ref={gridApiRefL}
                columnConfig={columns2}
                rowData={dataSource2}
                isEditable={false}
                rowSelection="single"
                onFocusedRowChanged={onFocusedRowChanged}
                resizeController={{
                  defaultSize: defaultSize,
                  onResizeStop: onResizeStop,
                }}
              />
            </SnResizable>
          </div>
        </SnResizable>
        <SnResizable
          direction={"height"}
          seq={3}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel3}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minWidth={130}
        >
          <SnGrid
            
            seq={3}
            ref={gridApiRefS}
            columnConfig={columns3}
            rowData={dataSource3}
            enableExternalChart={false}
            isEditable={true}
            rowSelection="multiple"
            title="-"
            rowDragManaged={true}
            resizeController={{
              defaultSize: defaultSize,
              onResizeStop: onResizeStop,
            }}
            header={
              <div className="relative space-x-2">
                <SnLabel text="매입일" type="string"></SnLabel>
                <div style={{ width: 150 }}>
                  <SnDateBox
                    onValueChanged={onValueChanged}
                    defaultValue={todayform}
                  ></SnDateBox>
                </div>
                <SnLabel text="매입담당자" type="string"></SnLabel>
                <div style={{ width: 150 }}>
                  <SnCodeBox
                    defaultValue={userInfo.cd_emp}
                    code="POPUP_EMP"
                    onValueChanged={onValueChanged3}
                  ></SnCodeBox>
                </div>
                <SnLabel text="영업그룹" type="string"></SnLabel>
                <div style={{ width: 150 }}>
                  <SnComboBox
                    code="MAS_GP"
                    defaultValue={userInfo.cd_gp}
                    onValueChanged={onValueChanged2}
                  ></SnComboBox>
                </div>
                <SnLabel text="수금예정일" type="string"></SnLabel>
                <div style={{ width: 150 }}>
                  <SnDateBox
                    onValueChanged={onValueChanged1}
                    defaultValue={todayform}
                  ></SnDateBox>
                </div>
                <div style={{ width: 130 }}>
                  <SnButton
                    text="마감전개"
                    onClick={() => {
                      grid3Btnclick("clsdev");
                    }}
                  ></SnButton>
                </div>
              </div>
            }
          />
        </SnResizable>
      </div>
    </div>
  );

  //#endregion
});

export default SN_SAL_STX_REG_002;
